// What both tenant surfaces — the directory (`pages/TenantsPage.tsx`) and the tenant's own page
// (`pages/TenantPage.tsx`) — need to draw a customer. Shared rather than copied, because the two must
// agree: the same customer has to wear the same two letters on the row the operator clicked and on the
// page it opened, or the page reads as a different tenant.

/**
 * Write `text` to the clipboard and confirm only when the write actually resolves. In a browser or test
 * environment without clipboard access it is a no-op rather than a false confirmation — the operator must
 * be able to trust "copied" before they paste the value into Keycloak.
 */
export function copyToClipboard(text: string, onDone: () => void) {
  if (!navigator.clipboard?.writeText) return;
  navigator.clipboard.writeText(text).then(onDone).catch(() => {
    /* clipboard unavailable — leave it a no-op */
  });
}

/**
 * Initials for the monogram, from the SLUG — the only name this console has (ADR-0014 §7.3).
 * Hyphen-separated words, so `acme-oy` reads as AY, and a single word gives its first two letters.
 */
export function monogram(name: string): string {
  const parts = name.trim().split(/[\s-]+/).filter(Boolean);
  if (parts.length === 0) return "?";
  if (parts.length === 1) return parts[0].slice(0, 2).toUpperCase();
  return (parts[0][0] + parts[parts.length - 1][0]).toUpperCase();
}
